import { forgetSavedLogin } from "@/utils/savedLogin";

/*
  這台裝置登入過的帳號（「切換帳號」的清單，2026-10-30）。

  每次認出登入的是誰（store 的 SyncFullProfile）就記一筆：email、姓名、頭像、上次用什麼方式登入。
  不存密碼 —— App 的密碼在手機 Keystore（utils/savedLogin.js），網頁交給瀏覽器的密碼管理員。

  最多 5 個，超過時拿掉最久沒用的那個（連同 App 存的密碼）。
  使用者可以在切換清單裡把某個帳號從這台裝置移除。

  登入方式：登入成功的地方先呼叫 markLoginMethod（帳密 password、Google google），
  緊接著的 SyncFullProfile 記帳號時取用。Google 登入會先整頁跳走再回來，所以記在 localStorage，
  10 分鐘內有效。不知道的（這個功能上線前就登入的）記 null，切換時兩種登入方式都給。
*/

const KEY = "_knownAccounts";
const METHOD_KEY = "_loginMethod";
const METHOD_TTL_MS = 10 * 60 * 1000;
export const MAX_KNOWN_ACCOUNTS = 5;

export const sameEmail = (a, b) => String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();

function read() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(list) ? list.filter((a) => a && a.email) : [];
  } catch (e) {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    /* 寫不進去就算了 */
  }
}

/** 最近用過的排前面 */
export function listKnownAccounts() {
  return read().sort((a, b) => (b.lastUsedAt || 0) - (a.lastUsedAt || 0));
}

/** 登入成功時呼叫：password（帳密）或 google */
export function markLoginMethod(method) {
  try {
    localStorage.setItem(METHOD_KEY, JSON.stringify({ method, at: Date.now() }));
  } catch (e) {
    /* 略過 */
  }
}

function takeLoginMethod() {
  try {
    const raw = JSON.parse(localStorage.getItem(METHOD_KEY));
    localStorage.removeItem(METHOD_KEY);
    if (raw && raw.method && Date.now() - raw.at < METHOD_TTL_MS) return raw.method;
  } catch (e) {
    /* 略過 */
  }
  return null;
}

/** 記下（或更新）目前登入的帳號，排到最前面；超過上限拿掉最久沒用的 */
export function rememberAccount({ email, name, photoUrl }) {
  if (!email) return;
  const list = read();
  const existing = list.find((a) => sameEmail(a.email, email));
  const entry = {
    email,
    name: name || (existing && existing.name) || "",
    photoUrl: photoUrl || "",
    method: takeLoginMethod() || (existing && existing.method) || null,
    lastUsedAt: Date.now(),
  };
  const others = list.filter((a) => !sameEmail(a.email, email)).sort((a, b) => (b.lastUsedAt || 0) - (a.lastUsedAt || 0));
  const next = [entry, ...others];
  write(next.slice(0, MAX_KNOWN_ACCOUNTS));
  next.slice(MAX_KNOWN_ACCOUNTS).forEach((a) => forgetSavedLogin(a.email));
}

/** 從這台裝置移除（連同 App 存的密碼） */
export function forgetAccount(email) {
  write(read().filter((a) => !sameEmail(a.email, email)));
  return forgetSavedLogin(email);
}
